const FIGMA_LABEL: Record<string, string> = {
  // 문제 분야 세부 14종 — Figma 119:11655
  cat_care: '🤲 돌봄',
  cat_education: '📚 교육',
  cat_housing: '🏠 주거',
  cat_food: '🍚 먹거리',
  cat_safety: '🦺 안전',
  cat_health: '💊 건강·의료',
  cat_environment: '🌎 환경',
  // 시안이 이모지와 글자를 붙여 놨다. 그대로 둔다.
  cat_culture: '🎨문화·여가',
  cat_mobility: '🚌 교통·이동',
  cat_isolation: '🫂 고립·관계',
  cat_digital: '💻 디지털·정보격차',
  cat_job: '💼 일자리·창업',
  cat_rights: '⚖️ 권익·법률·행정',
  cat_etc: '📌 기타',

  // 주 대상 — Figma 119:13863. 시안이 짧게 쓴 한 곳만 덮는다.
  tgt_resident: '지역주민',
}

export function figmaLabel(code: string, dbLabel: string): string {
  return FIGMA_LABEL[code] ?? dbLabel
}

const CATEGORY_ORDER = [
  'cat_care',
  'cat_education',
  'cat_housing',
  'cat_food',
  'cat_safety',
  'cat_health',
  'cat_environment',
  'cat_culture',
  'cat_mobility',
  'cat_isolation',
  'cat_digital',
  'cat_job',
  'cat_rights',
  'cat_etc',
]

export function sortByFigma<T extends { code: string }>(items: T[]): T[] {
  const rank = (code: string) => {
    const i = CATEGORY_ORDER.indexOf(code)
    return i === -1 ? CATEGORY_ORDER.length : i
  }
  return [...items].sort((a, b) => rank(a.code) - rank(b.code))
}

const CATEGORY_HALF_WIDTH = new Set(['cat_isolation', 'cat_digital', 'cat_job', 'cat_rights'])

export function isHalfWidthCategory(code: string): boolean {
  return CATEGORY_HALF_WIDTH.has(code)
}
